import Denmark from "../../assets/icons/svg/denmark_fav.svg";
import DailymotionIcon from "../../assets/icons/svg/dailymotion-icon.svg";

const jobTypeIcons: { [key: string]: any } = {
  youtube: (className: string, status: number, size: number) => (
    <i
      className={`bi-youtube ${className}`}
      style={{
        color: status !== 10 ? "gray" : "red",
        fontSize: size,
        lineHeight: 1,
      }}
    ></i>
  ),
  facebook: (className: string, status: number, size: number) => (
    <i
      className={`bi bi-facebook ${className}`}
      style={{
        color: status !== 10 ? "gray" : "blue",
        fontSize: size,
        lineHeight: 1,
      }}
    />
  ),
  linkedin: (className: string, status: number, size: number) => (
    <i
      className={`bi bi-linkedin ${className}`}
      style={{
        color: status !== 10 ? "gray" : "#0077B5",
        fontSize: size,
        lineHeight: 1,
      }}
    />
  ),
  instagram: (className: string, status: number, size: number) => (
    <i
      className={`bi bi-instagram ${className}`}
      style={{
        color: status !== 10 ? "gray" : "#E1306C",
        fontSize: size,
        lineHeight: 1,
      }}
    />
  ),
  twitter: (className: string, status: number, size: number) => (
    <i
      className={`bi bi-twitter ${className}`}
      style={{
        color: status !== 10 ? "gray" : "#1DA1F2",
        fontSize: size,
        lineHeight: 1,
      }}
    />
  ),
  denmark: (className: string, status: number, size: number) => (
    <img
      src={Denmark}
      alt="Denmark"
      className={className}
      width={size || 14}
      height={size || 14}
    />
  ),
  denmark_embed: (className: string, status: number, size: number) => (
    <img
      src={Denmark}
      alt="Denmark Embed"
      className={className}
      width={size || 14}
      height={size || 14}
    />
  ),
  dailymotion: (className: string, status: number, size: number) => (
    <img
      src={DailymotionIcon}
      width={size || 14}
      height={size || 14}
      alt="Dailymotion"
      className={className}
    />
  ),
  video: (className: string, status: number, size: number) => (
    <i
      className={`bi bi-camera-video ${className}`}
      style={{ color: "gray", fontSize: size }}
    />
  ),
};

export const PublishedIcon = ({
  job_type,
  className,
  status = 0,
  size,
  showQuestionCircle = true,
}: {
  job_type: string;
  className?: string;
  status?: number;
  size?: number;
  showQuestionCircle?: boolean;
}) => {
  const Icon =
    jobTypeIcons[job_type] ||
    ((className: string) =>
      showQuestionCircle ? (
        <i className={`bi bi-question-circle ${className}`} />
      ) : null);

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        lineHeight: 1,
      }}
    >
      {Icon(className || "", status, size)}
    </span>
  );
};
